import {
  AppKind,
  TellentNavigationHttpContract,
  TellentNavigationItem,
  TellentNavigationSection,
} from '@core/tellent-types';

// temporary solution until we update API contract

const updateNavigationItems = (
  items: TellentNavigationItem[],
  appKind: AppKind,
): TellentNavigationItem[] =>
  items.map(item => {
    switch (item.type) {
      case 'link':
        return {
          ...item,
          appKind,
        };

      case 'group':
        return {
          ...item,
          id: item.id ?? `${appKind}_${item.label}`,
          children: updateNavigationItems(item.children, appKind),
        };

      default:
        return item;
    }
  });

const updateSections = (sections: TellentNavigationSection[]) =>
  sections
    .filter(section => section.children.length)
    .map(section => ({
      ...section,
      children: updateNavigationItems(section.children, section.appKind),
    }));

const extractDashboardAndProfileFromCoreHr = (
  sections: TellentNavigationSection[],
): TellentNavigationItem[] => {
  const coreHrSection = sections.find(section => section.appKind === 'core_hr');
  if (!coreHrSection) return sections;

  const otherSections = sections.filter(section => section !== coreHrSection);

  const coreHrExtractedElements = coreHrSection.children.filter(
    item => item.type === 'link' && ['dashboard', 'profile'].includes(item.page.id),
  );

  const coreHrWithoutExtractedElements = coreHrSection.children.filter(
    item => !coreHrExtractedElements.includes(item),
  );

  const updatedSections = [];

  if (coreHrSection) {
    updatedSections.push(...coreHrExtractedElements, {
      ...coreHrSection,
      children: coreHrWithoutExtractedElements,
    });
  }

  if (otherSections) {
    updatedSections.push(...otherSections);
  }

  return updatedSections;
};

export const patchMainNavContract = (
  data: TellentNavigationHttpContract,
): TellentNavigationHttpContract => ({
  ...data,
  sections: extractDashboardAndProfileFromCoreHr(
    updateSections(<TellentNavigationSection[]>data.sections),
  ),
});

export const patchSettingsNavContract = (
  data: TellentNavigationHttpContract,
): TellentNavigationHttpContract => ({
  ...data,
  sections: updateSections(<TellentNavigationSection[]>data.sections),
});
